<script setup lang="ts">
import { computed } from 'vue';
import type { NavBadgeKind } from '@/config/navItems';
import { useNavCounts } from '@/composables/useNavCounts';

const props = defineProps<{ kind: NavBadgeKind }>();
const { counts } = useNavCounts();

interface BadgeState {
  count: number | null;
  variant: 'critical' | 'muted';
}

const state = computed<BadgeState | null>(() => {
  if (!counts.value) {
    return { count: null, variant: 'muted' };
  }
  if (props.kind === 'open-issues') {
    const total = counts.value.openIssues.total;
    if (total === 0) return null;
    return {
      count: total,
      variant: counts.value.openIssues.critical > 0 ? 'critical' : 'muted',
    };
  }
  if (props.kind === 'sources-enabled') {
    const total = counts.value.sourcesEnabled;
    if (total === 0) return null;
    return { count: total, variant: 'muted' };
  }
  return null;
});
</script>

<template>
  <span
    v-if="state"
    class="ml-auto font-mono tabular-nums text-[11px] font-semibold px-1.5 py-px rounded-pill"
    :class="state.variant === 'critical'
      ? 'bg-red-100 text-red-700'
      : 'bg-navy-100 text-navy-700'"
    data-testid="nav-badge"
  >
    {{ state.count ?? '—' }}
  </span>
</template>
